import Vue from 'vue'
import VueRouter from 'vue-router'
import { registerGuards } from './guards'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { title: 'Login', requiresAuth: false },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
    meta: { title: 'Register', requiresAuth: false },
  },
  {
    path: '/dashboard',
    alias: ['/'],
    name: 'Dashboard',
    component: () => import('@/views/home/Dashboard.vue'),
    meta: { title: 'Dashboard', requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/profile/Profile.vue'),
    meta: { title: 'Profile', requiresAuth: true },
  },
  {
    path: '/workspaces',
    name: 'WorkspacesIndex',
    component: () => import('@/views/mission/WorkspacesIndex.vue'),
    meta: { title: 'Workspaces', requiresAuth: true },
  },
  {
    path: '/workspaces/:id',
    name: 'Workspace',
    component: () => import('@/views/mission/MissionControl.vue'),
    meta: { title: 'Workspace', requiresAuth: true },
  },
  {
    path: '/devices',
    name: 'Devices',
    component: () => import('@/views/mission/Devices.vue'),
    meta: { title: 'Devices', requiresAuth: true },
  },
  {
    path: '/devices/pair',
    name: 'DevicePairing',
    component: () => import('@/views/mission/NodePairing.vue'),
    meta: { title: 'Pair Device', requiresAuth: true },
  },
  {
    path: '/macros',
    name: 'Macros',
    component: () => import('@/views/mission/Macros.vue'),
    meta: { title: 'Macros', requiresAuth: true },
  },
  {
    path: '/qlc-macros',
    name: 'QlcMacros',
    component: () => import('@/views/mission/QlcMacros.vue'),
    meta: { title: 'QLC Macros', requiresAuth: true },
  },
  {
    path: '/mission-control',
    redirect: '/workspaces',
  },
  {
    path: '/mission-control/pairing',
    redirect: '/devices/pair',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

registerGuards(router)

export default router
